// extracted by mini-css-extract-plugin
export default {"divider":"FlipperDrawer_divider__fsIAY","container":"FlipperDrawer_container__k5k0l","column":"FlipperDrawer_column__WKbuM"};